// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loadingComponent_loaderContainer__STeEU","loader":"loadingComponent_loader__M58Dd","loaderAnimation":"loadingComponent_loaderAnimation__YSc4I"};